:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: 2px;
  max-width: 1920px;
}

.card-section {
  padding-top: calc(var(--spacer) * 6);
  margin-bottom: calc(var(--spacer) * 7);
}

.card-section-container {
  padding: 0 calc(var(--spacer) * 3) calc(var(--spacer) * 2) calc(var(--spacer) * 3);
}

gz-card {
  min-height: auto;
}

gz-card[class*='cursor'] {
  cursor: pointer;
}

gz-card[icon='ds-icon-MDR']::part(icon) {
  font-size: 15px;
}

gz-image-repo {
  border-top: 1px solid var(--chart-100-pressed);
  padding-top: calc(var(--spacer) * 4.6);
}

gz-image-repo::part(wrapper) {
  flex-direction: row;
}

gz-image-repo::part(slot-content) {
  margin-left: calc(var(--spacer) * 2);
  max-width: 400px;
}

.empty-description {
  color: var(--grey-layout-200-disabled);
  text-align: left;
}

.empty-title {
  text-align: left;
  margin-bottom: var(--spacer);
}

.card-section-title {
  color: var(--body-text-arrows-400);
  font-weight: 500;
  font-style: normal;
  font-size: var(--card-section-title);
}
